module.exports = __webpack_public_path__ + "static/img/banner.392cea1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner.png
// module id = P07D
// module chunks = 3